// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"122":"64cbec66","467":"329577b8","496":"bcf92e4c","517":"65fd51fb","573":"71a2e194","882":"1c7b7659"}[chunkId] + ".chunk.js";
};